import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3984dd4a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3984dd4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3984dd4a')) {
      api.createRecord('3984dd4a', component.options)
    } else {
      api.reload('3984dd4a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3984dd4a&scoped=true&", function () {
      api.rerender('3984dd4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/dashboard/index.vue"
export default component.exports